import React from 'react'
import TextField from '@mui/material/TextField'

const CustomTextField = ({ label, variant, value, onChange, ...props }) => {
  return <TextField label={label} variant={variant || 'outlined'} value={value} onChange={onChange} {...props} />
}

export default CustomTextField
